import {use, useEffect} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';

import ReviewNRating from '../../../../../stories/components/hotels/DetailsPageUnif/RnRV2/ReviewNRating/ReviewNRating';

// CONFIG
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {getPageName, getUnifPageName} from '@stencil/hotels-utils/src/seo-utils';

// Omniture Imporrts
import useOmnitureImpressions from '@stencil/omniture-analytics/src/hooks/useOmnitureImpressions';
import {omnitureConfig, omnitureThunk} from '@stencil/omniture-analytics/src';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';
import {useLocation, useParams} from 'react-router-dom';
import {
  sortingCriterionListSelector,
  ugcReviewDataSelector,
  ugcSummarySelector,
} from '@stencil/hotels-cg-reducer/src/ugc/selectors';
import {isObjectEmpty} from '@stencil/hotels-utils/src/common-utils';

const RnRStyledWrapper = styled.div(
  props => `
  margin: 0 0 ${props.theme.spacing.xxlarge} 0
`,
);

const RNR = ({travellerImpressions = false}) => {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();

  const ugcSummary = useSelector(ugcSummarySelector);
  const sortingList = useSelector(sortingCriterionListSelector);
  const {sortBy: defaultSortOption = ''} = useSelector(ugcReviewDataSelector);

  const {source, cumulativeRating, availableOTAs} = ugcSummary ?? {};

  const pageNameSlug = getUnifPageName(location?.search, params);
  const pageName = getPageName(pageNameSlug);

  const [omniWatcherRef] = useOmnitureImpressions(
    DetailsPageComponents.Reviews,
    omnitureConfig.pages.DetailsUnif,
    {
      reviews: `${DetailsPageComponents.GuestReviewsLoaded}_loaded|${source}`,
    },
  );

  useEffect(() => {
    if (travellerImpressions && !isObjectEmpty(ugcSummary?.seekTagDetails)) {
      dispatch(
        omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
          cta: {
            name: DetailsPageComponents.TravelImpression,
            type: omnitureConfig.ctaType.Card,
            componentName: DetailsPageComponents.TravelImpression,
          },
        }),
      );
    }
  }, [travellerImpressions, ugcSummary]);

  if (!availableOTAs?.length || !cumulativeRating) {
    return <div id="dontHaveData" />;
  }

  return (
    <RnRStyledWrapper
      id={detailsNavigationIds.guestReviews}
      data-testid="rnrComponent"
      ref={omniWatcherRef}
    >
      <ReviewNRating
        ugcSummary={ugcSummary}
        sortingList={sortingList}
        defaultSortOption={defaultSortOption}
        seekTagDetails={ugcSummary?.seekTagDetails}
        travellerImpressions={travellerImpressions}
      />
    </RnRStyledWrapper>
  );
};

export default RNR;
